/*  app/ui/social/instagram-timeline */
define(
	'app/ui/social/instagram-timeline',[
		'jquery'
	],
	function ($) {
		'use strict';
		var InstagramTimeline;

		var token = '4466617201.1677ed0.0a1314f5cdcb475e84547d62f2c7477b';
		var requestUrl = 'https://api.instagram.com/v1/users/self/media/recent';
		var numPhotos = 8;
		var numShowMobile = 4;

		return {
			init: function() {
				var $timelineInstagram = $('.js-instagram-timeline');
				if ($timelineInstagram.length) {
					require(
						[
							'templayed',
							'text!templates/instagram-timeline.html'
						],
						function(templayed, instaTemplate) {
							// Templayed cannot handle carriage returns
							instaTemplate = instaTemplate.replace(/\r/g, '');
							InstagramTimeline = this;
							var userName;
							var avatarUrl;
							var $instagramWidget = $('#instagram-timeline');
							$.ajax({
								url: requestUrl,
								dataType: 'jsonp',
								type: 'GET',
								data: { access_token: token, count: numPhotos },
								success: function(data) {
									//console.log(data);
									var templateData = {
										accountAvatarUrl: '',
										accountName: '',
										posts: []
									};
									for (var x in data.data) {
										templateData.posts.push({
											hidden: x >= numShowMobile,
											postLink: data.data[x].link,
											postImageUrl: data.data[x].images.low_resolution.url,
											postLikeNum: String(data.data[x].likes.count),
											postCommentNum: String(data.data[x].comments.count)
										});
										if (!userName) {
											userName = data.data[x].user.username;
										}
										if (!avatarUrl) {
											avatarUrl = data.data[x].user.profile_picture;
										}
									}
									templateData.accountAvatarUrl = avatarUrl;
									templateData.accountName = userName;
									$instagramWidget.html(templayed(instaTemplate)(templateData));
								},
								error: function(data) {
									console.error(data);
								}
							});
						}
					);
				}

			}
		};
	}
);
